import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

const TOAST_OPTIONS = {
  style: {
    background: "rgba(20,20,20,0.95)",
    border: "1px solid rgba(255,32,121,0.3)",
    color: "#fff",
    fontFamily: "'Outfit', sans-serif",
  },
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" theme="dark" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
